// import { over } from "lodash";
import React from "react";
import { IChartGroups } from "utils/interfaces/report";
import { GraphType } from "utils/enums/graph";
import GraphReportTable from "components/GraphReportTable";
import { GRAPH_TYPE_LABELS } from "utils/constants/report";
import { Typography } from "@mui/material";
import CommonBarChart from "./commonBarChart";

interface IPDFGroupedBarChartProps {
  chartData: IChartGroups[];
  percentageData: IChartGroups[];
  categories: string[];
  graphType: GraphType;
  isYearSelected: boolean;
  colorValueMap: Record<string, string>;
  totalEnrolments: number;
  registerRef: (el: HTMLDivElement | null, idx: number) => void;
  index: number;
}

const PDFGroupedBarChart: React.FC<IPDFGroupedBarChartProps> = (props) => {
  const {
    chartData,
    percentageData,
    categories,
    graphType,
    colorValueMap,
    isYearSelected,
    totalEnrolments,
    registerRef,
    index,
  } = props;

  return (
    <div
      className="service-chart-box"
      ref={(el) => registerRef(el, index)}
      key={`${graphType}-pdf-component`}
    >
      <div
        style={{
          minWidth: "900px",
          width: 1000,
          padding: "15px",
        }}
      >
        <Typography variant="h2" align="center">
          {GRAPH_TYPE_LABELS[graphType]}
        </Typography>
        <CommonBarChart
          categories={categories}
          percentageData={percentageData}
          graphType={graphType}
          isAnimationActive={false}
          colorValueMap={colorValueMap}
          totalEnrolments={totalEnrolments}
          isPrintComponent
        />
        <div className="terms-box">
          <span className="arrow-line" />
          <span>{isYearSelected ? "Years" : "Terms"}</span>
        </div>
        <GraphReportTable
          data={chartData}
          optionList={categories}
          graphType={graphType}
          percentageData={percentageData}
          colorValueMap={colorValueMap}
        />
      </div>
    </div>
  );
};

export default PDFGroupedBarChart;
